import React from "react";

interface IconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const QuestionMarkIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 1.99984C11.3137 1.99984 14 4.68613 14 7.99984C14 11.3135 11.3137 13.9998 7.99998 13.9998C4.68627 13.9998 1.99998 11.3135 1.99998 7.99984C1.99998 4.68613 4.68627 1.99984 7.99998 1.99984ZM14.6666 7.99984C14.6666 4.31794 11.6819 1.33317 7.99998 1.33317C4.31808 1.33317 1.33331 4.31794 1.33331 7.99984C1.33331 11.6817 4.31808 14.6665 7.99998 14.6665C11.6819 14.6665 14.6666 11.6817 14.6666 7.99984Z"
        fill="white"
      />

      <path
        d="M7.34511 6.71399H8.47719C8.48015 6.94398 8.51122 7.14261 8.57042 7.30987C8.63257 7.47714 8.748 7.63693 8.9167 7.78926C9.11204 7.97445 9.2911 8.15366 9.45388 8.3269C9.61666 8.50014 9.74837 8.68681 9.849 8.88693C9.94963 9.09004 9.99994 9.32152 9.99994 9.58138C9.99994 9.95474 9.92151 10.2713 9.76465 10.5312C9.60778 10.794 9.38137 10.9927 9.0854 11.1271C8.78943 11.2645 8.43427 11.3332 8.01992 11.3332C7.64404 11.3332 7.30516 11.2675 7.00327 11.136C6.70138 11.0076 6.46017 10.809 6.27963 10.5402C6.10205 10.2743 6.00882 9.93681 5.99994 9.52762H7.2874C7.29036 9.7128 7.32587 9.86214 7.39395 9.97564C7.46498 10.0891 7.55525 10.1728 7.66476 10.2265C7.77426 10.2833 7.89265 10.3117 8.01992 10.3117C8.17382 10.3117 8.30109 10.2818 8.40172 10.2221C8.5053 10.1623 8.58226 10.0742 8.63257 9.95772C8.68584 9.84422 8.71248 9.70085 8.71248 9.52762C8.71248 9.37827 8.68288 9.24237 8.62369 9.11991C8.5645 9.00043 8.48311 8.88395 8.37952 8.77045C8.27593 8.65695 8.15458 8.53747 8.01548 8.41202C7.84974 8.25671 7.71655 8.0999 7.61592 7.94159C7.51825 7.78329 7.4487 7.60557 7.40726 7.40844C7.36879 7.21429 7.34807 6.98281 7.34511 6.71399Z"
        fill="white"
      />
      <path
        d="M7.40726 5.8045C7.27704 5.67905 7.21193 5.52074 7.21193 5.32959C7.21193 5.1444 7.27704 4.98759 7.40726 4.85916C7.53749 4.73072 7.71211 4.6665 7.93113 4.6665C8.14718 4.6665 8.32032 4.73072 8.45055 4.85916C8.58374 4.98759 8.65033 5.1444 8.65033 5.32959C8.65033 5.52074 8.58374 5.67905 8.45055 5.8045C8.32032 5.93293 8.14718 5.99715 7.93113 5.99715C7.71211 5.99715 7.53749 5.93293 7.40726 5.8045Z"
        fill="white"
      />
    </svg>
  );
};

export default QuestionMarkIcon;
